// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useLedgerEnd } from '@hooks/queries/ledger/useLedgerEnd';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { TransferOffer } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Model/Transfer';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';

export const useTransferOffers: () => UseQueryResult<
  TemplateContract<TransferOffer>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  const offset = useLedgerEnd();

  return useQuery({
    queryKey: ['queryTransferOffers', offset, ledgerApi, operator],
    queryFn: async () => {
      return ledgerApi.queryTransferOffers(offset!, operator);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};
